import { isSSA } from '../is-ssa/is-ssa';

/**
 * Platform Helper
 */

export namespace PlatformHelper {
  export const isIOS = (): boolean =>
    isCordova() &&
    !!navigator.platform &&
    /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);

  export const isAndroid = (): boolean =>
    !!navigator.userAgent && /(android)/i.test(navigator.userAgent);

  export const isElectron = (): boolean =>
    process.env.PLATFORM === 'ia32' || process.env.PLATFORM === 'x64';

  // #TODO is this working???
  export const isCordova = (): boolean => process.env.PLATFORM === 'cordova';

  export const isBrowser = (): boolean => process.env.PLATFORM === 'browser';

  export const isDesktop = (): boolean =>
    !PlatformHelper.isElectron() &&
    !PlatformHelper.isIOS() &&
    !PlatformHelper.isCordova();

  export const isDesktopElectron = (): boolean =>
    PlatformHelper.isElectron() &&
    window.screen.orientation.angle === 0 &&
    window.screen.orientation.type === 'landscape-primary';

  export const isTouchDevice = (): boolean => {
    if (isSSA()) {
      return true;
    }
    return 'ontouchstart' in window;
  };
}
